import * as types from "@/store/mutation-types";
import store from "@/store";
import router from "@/router";
import {
  getAsync,
  postAsync,
  putAsync,
  setAuthorizationHeader,
  deleteAsync
} from "@/http-common";
import axios from 'axios'


export async function updateOrdersMeetingsList ({ commit }, meetingsListOrdered) {
    let res = false
    commit('UPDATE_LOADING_ORDERED_LIST', true)
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters["auth/getToken"]
    await axios
      .post(
        process.env.URL_SSO_API +
          'brainstorming/board/colidee/' +
          store.state.auth.idEntreprise +
          '/' +
          store.state.auth.idPlateforme +
          '/updateOrdersMeetingsList',
        meetingsListOrdered
      )
      .then(response => {
        if (response.status === 200) {
          commit('UPDATE_LOADING_ORDERED_LIST', false)
          commit('UPDATE_TOAST_ORDERED_LIST', true)
          res =  true
        } 
      })
      .catch(err=>{
        console.error(err);
      })
      return res
  }

export async function createLink({ commit, dispatch }, payload) {
  var data = new FormData();
  data.append("parent", payload.parent);
  data.append("child", payload.child);
  data.append("color", payload.color);
  data.append("relation", payload.relation);
  data.append("board", payload.board.id);
  data.append("sheet_id", payload.sheet);

  commit(types.CREATE_LINK, {});

  let url = "brainstorming/public/board/" + payload.board.id + "/link";
  // console.log(data.getAll)
  let res = await postAsync(url, data, {  
      urlparticipant: payload.board && payload.board.url_participant ? payload.board.url_participant:null,
      urlmoderateur: payload.board && payload.board.url_moderateur ? payload.board.url_moderateur:null 
    });
  // console.log(res)

  // return res
}

export async function listAvailaible({ commit, dispatch }) {
  setAuthorizationHeader(store.getters["auth/getToken"]);
  let idEntreprise = store.getters["auth/idEntreprise"];
  let idPlateforme = store.getters["auth/idPlateforme"];
  // let idPlateforme = store.
  var res = await getAsync(
    `brainstorming/board/boards${
      idEntreprise && idPlateforme
        ? "/" + idEntreprise + "/" + idPlateforme
        : ""
    }`
  );
  var boards = [];
  if (res.data && Array.isArray(res.data)) {
    boards = res.data;
    // console.log(boards);
    boards.forEach(board => {
      // console.log(board.colours)
      board.colours = JSON.parse(board.colours);
    });
    // console.log(boards)
  }
  commit(types.LIST_ALL_BOARD, { boards });
  if (store.getters["auth/getInitSearch"]) {
    commit(types.RECHERCHE_BOARD, store.getters["auth/getInitSearch"]);
    store.dispatch("auth/setInitSearch");
  }
}

export async function newBoard({ commit, dispatch }, payload) {
  while (typeof payload.colours === "string") {
    payload.colours = JSON.parse(payload.colours);
  }
  var data = {
    name: payload.name,
    client: payload.client,
    evenement: payload.evenement,
    open_at:
      payload.open_at !== null
        ? new Date(
            payload.open_at.getTime() -
              payload.open_at.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T")[0]
        : "1970-01-01 00:00:00",
    close_at:
      payload.close_at !== null
        ? payload.close_at.toISOString().replace('T', ' ').replace('Z','').replace('22:59:59','23:59:59')
        : "1970-01-01 00:00:00",
    description: "",
    id_entreprise: store.getters["auth/idEntreprise"],
    id_plateforme: store.getters["auth/idPlateforme"],
    colours: JSON.stringify(payload.colours),
    active: payload.active,
    mode: payload.mode,
    password: null,
    shares: ""
  };
  if (payload.template_id !== "null") {
    data.template_id = payload.template_id;
  } else {
    data.template_id = null;
  }

  if (payload.shares.length > 0) {
    payload.shares.forEach(element => {
      if (data.shares === "") {
        data.shares += element;
      } else {
        data.shares += ";" + element;
      }
    });
  }
  setAuthorizationHeader(store.getters["auth/getToken"]);
  var res = {};
  var board = {};
  if (payload.id !== null) {
    res = await putAsync("brainstorming/board/" + payload.id, data);
    board = res.data;
    console.log('update Success')
    window.top.postMessage({task: 'updateColidee'}, '*')
    commit(types.UPDATE_BOARD, { board });
  } else {
    res = await postAsync("brainstorming/board", data);
    board = res.data;
    console.log('save Success')
    window.top.postMessage({task: 'updateColidee'}, '*')
    commit(types.NEW_BOARD, { board });
  }
  commit(types.RECHERCHE_BOARD, "");
}

export async function deleteBoard({ commit, dispatch }, payload) {
  setAuthorizationHeader(store.getters["auth/getToken"]);
  await deleteAsync("brainstorming/board/" + payload);
  console.log('delete Success')
  window.top.postMessage({task: 'updateColidee'}, '*')
  commit(types.DELETE_BOARD, payload);
  commit(types.RECHERCHE_BOARD, "");
}

export async function resetBoard({ commit, dispatch }, payload) {
  setAuthorizationHeader(store.getters["auth/getToken"]);
  var res = await deleteAsync("brainstorming/board/" + payload + "/reset");
  var board = res.data;
  commit(types.UPDATE_BOARD, { board });
  commit(types.RECHERCHE_BOARD, "");
}

export async function loadBoard({ commit, dispatch }, payload) {
  setAuthorizationHeader(store.getters["auth/getToken"]);
  var res = await getAsync("brainstorming/board/" + payload.id);
  var board = res.data;
  board.posts_count = payload.posts_count
  commit(types.EDIT_BOARD_DATA, board);
  commit(types.NEW_BOARD_POPUP_STATE, true);
  commit(types.URL_MODERATEUR, payload.url_moderateur);
}
export async function loadBoardData({ commit, dispatch }, payload) {
  commit(types.IS_LOADING, true);
  var res = await getAsync(
    "brainstorming/public/board/" + payload.board.id + "/post",
    {  
      urlparticipant: payload.board && payload.board.url_participant ? payload.board.url_participant:null,
      urlmoderateur: payload.board && payload.board.url_moderateur ? payload.board.url_moderateur:null 
    }
  );
  var post = res.data;
  commit(types.BOARD_DATA_LOADED, { post });
  commit(types.IS_LOADING, false);
  // res = await getAsync('brainstorming/public/board/' + payload.board.id + '/shape', {'urlparticipant': payload.board.url_participant})
  // console.log(res.data)
}

export async function newPost({ commit, dispatch }, payload) {
  /* var data = {
    contenu: payload.post.contenu,
    coord_x: payload.post.coord_x,
    coord_y: payload.post.coord_y,
    couleur: payload.post.couleur,
    sheet_id: payload.post.sheet_id,
    etat: payload.post.etat,
    media : payload.post.media,
    link : payload.post.link
  } */
  var data = new FormData();
  data.append("contenu", payload.post.contenu);
  data.append("coord_x", payload.post.coord_x);
  data.append("coord_y", payload.post.coord_y);
  if (
    payload.post.couleur !== undefined ||
    payload.post.couleur !== "undefined"
  ) {
    data.append("couleur", payload.post.couleur);
  } else {
    data.append("couleur", "rgb(112, 209, 248)");
  }
  data.append("sheet_id", payload.post.sheet_id);
  data.append("etat", payload.post.etat);
  if (payload.post.link) {
    data.append("link", payload.post.link);
  }
  if (payload.post.media) {
    data.append("media", payload.post.media);
  }
  // console.log(data.getAll)
  let res = await postAsync(
    "brainstorming/public/board/" + payload.board.id + "/post",
    data,
   {  
      urlparticipant: payload.board && payload.board.url_participant ? payload.board.url_participant:null,
      urlmoderateur: payload.board && payload.board.url_moderateur ? payload.board.url_moderateur:null 
    }
  );
  return res;
}
export async function newSheet({ commit, dispatch }, payload) {
  var data = payload.sheet;
  await postAsync(
    "brainstorming/public/board/" + payload.board.id + "/sheet",
    data,
    {  
      urlparticipant: payload.board && payload.board.url_participant ? payload.board.url_participant:null,
      urlmoderateur: payload.board && payload.board.url_moderateur ? payload.board.url_moderateur:null 
    }
  );
}
export async function deleteSheet({ commit, dispatch }, payload) {
  await deleteAsync(
    "brainstorming/public/board/" +
      payload.board.id +
      "/sheet/" +
      payload.sheet,
    {  
      urlparticipant: payload.board && payload.board.url_participant ? payload.board.url_participant:null,
      urlmoderateur: payload.board && payload.board.url_moderateur ? payload.board.url_moderateur:null 
    }
  );
}
export async function updateSheet({ commit, dispatch }, payload) {
  var data = payload.sheet;
  await putAsync(
    "brainstorming/public/board/" +
      payload.board.id +
      "/sheet/" +
      payload.sheet.id,
    data,
    {  
      urlparticipant: payload.board && payload.board.url_participant ? payload.board.url_participant:null,
      urlmoderateur: payload.board && payload.board.url_moderateur ? payload.board.url_moderateur:null 
    }
  );
}

export async function updatePostData({ commit, dispatch }, payload) {
  /* var data = {
    contenu: payload.post.contenu,
    coord_x: payload.post.x,
    coord_y: payload.post.y,
    couleur: payload.post.couleur,
    sheet_id: payload.post.sheet_id,
    etat: payload.post.etat,
    link: payload.post.link,
    like: payload.post.like
  } */

  // console.log(payload);

  var data = new FormData();
  data.append("_method", "PUT");
  data.append("contenu", payload.post.contenu);
  if (payload.post.coord_x || payload.post.coord_x === 0) {
    data.append("coord_x", payload.post.coord_x);
  }
  if (payload.post.coord_y || payload.post.coord_y === 0) {
    data.append("coord_y", payload.post.coord_y);
  }
  if (payload.post.couleur) {
    data.append("couleur", payload.post.couleur);
  }
  if (payload.post.sheet_id) {
    data.append("sheet_id", payload.post.sheet_id);
  }
  if (payload.post.folder_id || payload.post.folder_id === null) {
    data.append("folder_id", payload.post.folder_id);
  }
  if (payload.post.etat) {
    data.append("etat", payload.post.etat);
  }
  if (payload.post.like) {
    data.append("like", payload.post.like);
  }
  if (payload.post.link) {
    data.append("link", payload.post.link);
  }
  if (payload.post.zindex) {
    data.append("zindex", payload.post.zindex);
  }
  if (payload.post.media) {
    data.append("media", payload.post.media);
  }else{
    data.append("media", 0);

  }

  // await putAsync('brainstorming/public/board/' + payload.board.id + '/post/' + payload.post.id, data, {'urlparticipant': payload.board.url_participant})
  let res = await postAsync(
    "brainstorming/public/board/" +
      payload.board.id +
      "/post/" +
      payload.post.id,
    data,
    {  
      urlparticipant: payload.board && payload.board.url_participant ? payload.board.url_participant:null,
      urlmoderateur: payload.board && payload.board.url_moderateur ? payload.board.url_moderateur:null 
    }
  );
  return res;
}

export async function checkparticipant({ commit, dispatch }, payload) {
  commit(types.EMPTY_MEETING);
  var res = await getAsync("brainstorming/checkurlparticipant", {
    urlparticipant: payload.url
  });
  //verification open/close date and state
  console.log(res.data);
  var board = res.data;
  if(store.board && store.board.url_moderateur && store.board.url_moderateur.length > 0){ // Si modérateur, board toujours ouvert
    commit('OPEN_BOARD')
  } else {

    if ( // Si on a des dates d'ouvertures et de fermetures
      (res.data[0].open_at !== "1970-01-01 00:00:00" &&
        res.data[0].open_at !== null) ||
      (res.data[0].close_at !== "1970-01-01 00:00:00" &&
        res.data[0].close_at !== null)
    ) {

      //Traitement des dates
      if (
        res.data[0].open_at !== "1970-01-01 00:00:00" &&
        res.data[0].open_at !== null &&
        new Date(res.data[0].open_at.replace(" ", "T")) >= new Date() // Si on a une date d'ouverture et qu'elle est ultérieure à ajd
      ) {
        commit("CLOSE_BOARD") // on ferme le board
      } else if ( 
        res.data[0].close_at !== "1970-01-01 00:00:00" &&
        res.data[0].close_at !== null &&
        new Date(res.data[0].close_at.replace(" ", "T")) <= new Date() // Si on a une date de fermeture et qu'elle est antérieure à ajd
      ) {
        commit("CLOSE_BOARD") // on ferme leboard
      } else{
        // Etat d'ouverture égal état du board
        commit( board[0].active ? "OPEN_BOARD":"CLOSE_BOARD" )
      }

    } else{
      // Etat d'ouverture égal état du board
      commit( board[0].active ? "OPEN_BOARD":"CLOSE_BOARD" )
    }
  }
  if (board && typeof board === "object") {
    commit(types.LAUNCH_MEETING_PARTICIPANT, {
      board: board[0],
      url: payload.url
    });
  } else {
    let errorMsg = res.error ? res.error.response.data.trim() : res.data.trim();
    router.push({
      name: "home",
      params: { error: true, errorMsg }
    });
  }
  
}

export async function checkmoderateur({ commit, dispatch }, payload) {
  commit(types.EMPTY_MEETING);
  var res = await getAsync("brainstorming/checkurlmoderateur", {
    urlmoderateur: payload.url
  });

  var board = res.data;
  if (board && typeof board === "object") {
    commit(  "OPEN_BOARD" )
    commit(types.LAUNCH_MEETING_MODERATEUR, {
      board: board[0],
      url: payload.url
    });
  } else {
    router.push({
      name: "home",
      params: { error: true, errorMsg: board.trim() }
    });
  }
}

export async function getTemplates({ commit, dispatch }, payload) {
  //  if qui permet de vérifier si on est dans addBoardButton , si oui on passe le setAuthorization
  if (payload === "addBoardButton") {
    setAuthorizationHeader(store.getters["auth/getToken"]);
    var res = await getAsync("brainstorming/template");
  }
  // sinon si on a partagé la board on pousse l'urlModerateur
  else {
    var res = await getAsync("brainstorming/public/template", {
      urlmoderateur: payload
    });
  }
  var templates = res.data;
  templates = templates.filter(el => el.owner_id === null);
  commit(types.LOAD_TEMPLATES, templates);
}

export async function getBackgroundImage({ commit, dispatch }, payload) {
  var res = await getAsync(
    "brainstorming/public/board/" + payload.id + "/background",
    {  
      urlparticipant: payload.board && payload.board.url_participant ? payload.board.url_participant:null,
      urlmoderateur: payload.board && payload.board.url_moderateur ? payload.board.url_moderateur:null 
    }
  );
  if (res.data) {
    commit(types.SET_BG_IMAGE, res.data);
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/board/actions.js